module.exports = __webpack_public_path__ + "img/01.6dd07677.jpg";